import { formatDuration } from "common/utils/timesheet";

export const getOverrideDetails = (shift) => {
  const details = [];

  if (
    shift.projectOverridden &&
    shift.projectNameEmployee &&
    shift.projectName
  ) {
    details.push({
      label: "Shift tag",
      from: shift.projectNameEmployee,
      to: shift.projectName,
    });
  }

  if (shift.referenceNumberOverridden) {
    details.push({
      label: "Reference number",
      from: shift.referenceNumber || "none",
      to: shift.referenceNumber || "none",
    });
  }

  if (
    shift.hoursOverridden &&
    shift.hoursWorkedEmployee != null &&
    shift.hoursWorkedEmployer != null
  ) {
    details.push({
      label: "Total net paid hours",
      from: formatDuration(shift.hoursWorkedEmployee * 3600),
      to: formatDuration(shift.hoursWorkedEmployer * 3600),
    });
  }

  return details;
};
